import { gql } from "@apollo/client"

export type SingleStringValue = {
  value: string;
}

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export type LoginArgs = {
  username: string;
  password: string;
}

export interface LoginResponse {
  login: Def_MutationResponse;
}
export const USER_LOGIN = gql`
  query Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      code message success
    }
  }`;

export type CreateArgs = {
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}
export interface CreateUserResponse {
  createUser: Def_MutationResponse;
}
export const CREATE_USER = gql`
  query CreateUser($username: String!, $firstname: String, $lastname: String!, $phone: String!, $email: String!, $password: String!) {
    createUser(username: $username, firstname: $firstname, lastname: $lastname, phone: $phone, email: $email, password: $password) {
      code message success
    }
  }`;

export interface Farms_Data {
  farm_id: number
  name: string
  domain: string
}

export type UserFarmsArgs = {
  farm_id?: number;
}

export interface FarmsResponse {
  getUserFarms: Farms_Data[];
}
export const USER_FARMS = gql`
  query GetUserFarms {
    getUserFarms {
      farm_id
      name
      domain
    }
  }`;

export interface User_Data {
  user_id:number;
  username:string;
  firstname: string;
  lastname: string;
  phone: string;
  email: string;
  address: string;
  country: string;
}

export type UserInfoArgs = {
  jwt: string;
}

export interface UserInfoResponse {
  getUserInfo: User_Data;
}
export const USER_INFO = gql`
  query GetUserInfo($jwt: String!) {
    getUserInfo(jwt: $jwt) {
      username
      firstname
      lastname
      phone
      email
      address
      country
      user_id
    }
  }`;
  
export type UpdateUserInfoArgs = {
  jwt: string;
} & Partial<User_Data>

export interface UpdateUserInfoResponse {
  updateUserInfo: Def_MutationResponse;
}
export const UPDATE_USER_INFO = gql`
  mutation UpdateUserInfo($jwt: String!, $firstname: String!, $lastname: String!, $phone: String!, $email: String!, $address: String!, $country: String!) {
    updateUserInfo(jwt: $jwt, firstname: $firstname, lastname: $lastname, phone: $phone, email: $email, address: $address, country: $country) {
      code message success
    }
  }`;

  export interface Farm_Data {
    company_id: number;
    domain: string;
    name: string;
    city: string;
    street: string;
    phone: string;
    vat: string;
    email: string;
  }
  
  export type FarmInfoArgs = {
    domain: string;
  }
  
  export interface FarmInfoResponse {
    getFarmInfo: Farm_Data;
  }
  export const FARM_INFO = gql`
    query GetFarmInfo($domain: String!) {
      getFarmInfo(domain: $domain) {
        company_id
        domain
        name
        city
        street
        phone
        vat
        email
      }
    }`;
    
  export type UpdateFarmInfoArgs = {
    domain: string;
  } & Partial<Farm_Data>
  
  export interface UpdateFarmInfoResponse {
    updateFarmInfo: Def_MutationResponse;
  }
  export const UPDATE_FARM_INFO = gql`
    mutation UpdateFarmInfo(
    $domain: String!, 
    $city: String!, 
    $street: String!, 
    $phone: String!, 
    $vat: String!, 
    $email: String!
    ) {
      updateFarmInfo(
      domain: $domain,
      city: $city, 
      street: $street, 
      phone: $phone, 
      vat: $vat, 
      email: $email
      ) {
        code message success
      }
    }`;